import {MarkGithubIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import styles from './styles.module.css'
import {useGlobalNavAnalytics} from '../../utils/Analytics'

export interface HeaderLogoProps {
  href?: string
  'aria-label'?: string
  hotkey?: string
}

export function HeaderLogo(props: HeaderLogoProps) {
  const {sendItemClick} = useGlobalNavAnalytics()

  return (
    <IconButton
      as="a"
      href="/"
      variant="invisible"
      className={styles.appHeaderHome}
      icon={() => <MarkGithubIcon size="medium" />}
      data-hotkey={props.hotkey}
      keybindingHint={props.hotkey}
      aria-label="Dashboard"
      onClick={() => {
        sendItemClick('HEADER_LOGO')
      }}
      {...props}
    />
  )
}

try{ HeaderLogo.displayName ||= 'HeaderLogo' } catch {}